import {IOrdContract, IOrdPerson} from "../types/types";
import {DocType} from "../constants/constants";

const validateGoogleDocUrl = (urlString: string) => {
    try {
        const urlObj = new URL(urlString);

        return urlObj.hostname === 'docs.google.com' &&
            urlString.includes('/document/d/') &&
            /\/d\/[a-zA-Z0-9-_]+/.test(urlString);

    } catch {
        return false;
    }
};

const sleep = (ms: number) => {
    return new Promise((r) => setTimeout(r, ms));
}

const filterContractsByServiceNumber = (
    contracts: IOrdContract[],
    serviceNumber: string,
    type: DocType
): IOrdContract | undefined => {
    return contracts.find((contract: IOrdContract) => {
        const typeDoc = type === DocType.ADDITIONAL ? 'Договор №' : 'Приложение №'
        return `${typeDoc} ${serviceNumber}` === contract.serial;
    });
}

const filterPersonsByName = (
    persons: IOrdPerson[],
    personName: string
): IOrdPerson | undefined => {
    return persons.find((person: IOrdPerson) => {
        return person.name.toLowerCase().includes(personName.toLowerCase());
    });
}


const round2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;

// Получение суммы без НДС, зная сумму с НДС
const calcAmountFromIncluding = (including_vat: number, vat_rate: number) => {
    const rate = vat_rate / 100;
    const excluding_vat = round2(including_vat / (1 + rate));
    const vat = round2(including_vat - excluding_vat);

    return {
        excluding_vat,
        vat_rate,
        vat,
        including_vat,
    };
};

// Получение суммы с НДС, зная сумму без НДС
const calcAmountFromExcluding = (excluding_vat: number, vat_rate: number) => {
    const rate = vat_rate / 100;
    const vat = round2(excluding_vat * rate);
    const including_vat = round2(excluding_vat + vat);

    return {
        excluding_vat,
        vat_rate,
        vat,
        including_vat,
    };
};

const mapPersonsToOptions = (persons: IOrdPerson[]) => {
    return persons.map(person => ({
        value: person.client_external_id,
        label: person.name,
        data: person
    }));
};

export {
    validateGoogleDocUrl,
    sleep,
    filterContractsByServiceNumber,
    filterPersonsByName,
    calcAmountFromIncluding,
    calcAmountFromExcluding,
    mapPersonsToOptions,
    round2
}
